import React from "react";
import "./tope-privacy.scss";
export default function () {
  return (
    <div className="tope-privacy">
        <div className="content">
        Topu International Int-Topu International Technology Co., Ltd, the company operates the website: www.tope.com and related mobile applications (hereinafter referred to as "the platform"), and provides users with digital currency transactions and related services based on the platform.
      </div>
        <div className="content">
        The platform respects and protects the personal privacy of all users who use the platform's network services. In order to provide you with more accurate and personalized services, the platform will use and disclose your personal information in accordance with the provisions of this Privacy Policy. When you agree to the app registration service agreement, you are deemed to have accepted the entire content of this privacy agreement. This privacy agreement is an integral part of the agreement to use The app's network services. Please note that the platform will check and update the privacy policy from time to time, and we hope that you regularly review the content of this agreement to ensure that you understand the latest version of the privacy policy. If you have further questions about the platform privacy policy after reading this agreement, please contact  support@tope.com.
      </div>
      <div className="second-title">01. cope of application</div>
      <div className="content">
      A) When you register a platform account, the personal information you provide according to the requirements of the platform;
        <br />
        B) When you use the platform's network services or visit the platform's web pages, the platform automatically receives and records information on your browser and computer, including but not limited to your IP address, browser type, language used, Data such as access date and time, software and hardware feature information, and web page records you need;
        <br />
        C) User personal data obtained by the platform from business partners through legal channels.
        <br />
        You understand and agree that the following information does not apply to this Privacy Policy:
        <br />
        A) The keyword information you enter when using the search service provided by the platform;
        <br />
        B) The relevant information and data collected by the platform that you publish on the platform, including but not limited to posts published on the forum;
        <br />
        C) Violations of the law or platform rules and the measures the platform has taken against you.
        <br />
      </div>
      <div className="second-title">02. use of information</div>
      <div className="content">
      A) For the purpose of serving users, the platform may use your personal information to provide you with information that you are interested in, including but not limited to sending you product and service information, or sharing information with platform partners so that they can send you Information about its products and services (the latter requires your prior consent).
      </div>
      <div className="content">
      B) The platform will collect, organize and properly dispose of the information provided by users to the platform. For example, when a service is jointly launched by the platform and a partner company, the platform may have to share user information with the partner company when the user uses it. The platform will urge cooperative companies to protect user information in accordance with the provisions of this policy.
      </div>
   

      <div className="second-title">03. information disclosure</div>
      <div className="content">
      Under the following circumstances, the platform will disclose your personal information in whole or in part according to your personal wishes or legal provisions:
      </div>
      <div className="content">
      A) Disclosure to third parties with your prior consent;
      <br />
      B) In order to provide the products and services you requested, it is necessary to share your personal information with third parties;
      <br />
      C) According to the relevant provisions of the law, or the requirements of administrative or judicial agencies, disclose to third parties or administrative or judicial agencies;
      <br />
      D) If you have violated relevant laws, regulations or platform service agreements or related rules, you need to disclose it to a third party;
      <br />
      E) If you are a qualified intellectual property complainant and have filed a complaint, you should disclose it to the respondent at the request of the respondent so that both parties can handle possible rights disputes;
      <br />
      F) Other platforms consider appropriate disclosures in accordance with laws, regulations or website policies.
      </div>
      <div className="second-title">04. Information Storage and Exchange</div>
      <div className="content">
      The information and materials about you collected by the platform will be stored on the servers of the platform and/or its affiliated companies, and these information and materials may be transmitted to your country, region or overseas where the platform collects information and materials and accessed abroad , storage and display.
      </div>
 
      <div className="second-title">05. Use of cookies</div>
     
      <div className="content">
      A) If you do not refuse to accept cookies, the platform will set or access cookies on your computer so that you can log in or use platform services or functions that rely on cookies. The platform uses cookies to provide you with more thoughtful and personalized services, including promotional services.
      <br />
      B) You have the right to choose to accept or refuse to accept cookies. You can refuse to accept cookies by modifying your browser settings. However, if you choose to refuse to accept cookies, you may not be able to log in or use the platform web services or functions that rely on cookies.
      <br />
      C) This policy will apply to the relevant information obtained through the cookies set by the platform.
      <br />
   
      </div>
      <div className="second-title">06. information security</div>
     
      <div className="content">
      A) Platform accounts have security protection functions, please keep your username and password information properly. The platform will take security measures such as encrypting user passwords to ensure that your information is not lost, misused or altered. Despite the aforementioned security measures, please also note that there are no "perfect security measures" on the information network.
      <br />
      B) When using the platform's network services for online transactions, please properly protect your personal information and only provide it to others when necessary. If you find that your personal information is leaked, especially if the platform username and password are leaked, please contact the customer service of the platform immediately so that the platform can take corresponding measures.
      <br />
      </div>
      <div className="second-title">07. disclaimer</div>
     
      <div className="content">
      This website does not need to bear any responsibility under the following circumstances:
      <br />
      A) Any leakage of personal data caused by you informing others of your user password or sharing your registered account with others.
      <br />
      B) Any leakage, loss, theft or tampering of personal data caused by force majeure such as hacker attack, computer virus invasion or attack, temporary shutdown caused by government control, etc. that affect the normal operation of the network.
      <br />
      C) Disclosure of personal data caused by other websites linked to this website and any legal disputes and consequences arising therefrom.
      <br />
      </div>
      <div className="second-title">07. external link</div>
     
      <div className="content">
      The Platform contains links to some external websites. The platform is not responsible for the privacy management and behavior of these websites. When jumping to an external website, users should read the privacy policy of that website. The privacy policy provided here is only for the platform to collect and manage user information.

      </div>



      <div className="second-title">Connect</div>
      <div className="content">
      Topu Int official website: https://tope.com
      <br />
Topu APP download: https://download.tope.com <br />

Topu Telegram English channel: https://t.me/Topu_Ann <br />

Topu English Community: https://t.me/Topu_Int_GroupEN <br />

Topu H5 site: http://H5.tope.com <br />

Twitter: https://twitter.com/TopuEx <br />

Medium: https://medium.com/@Topu_International <br />
      </div>
  
    </div>
  );
}
